import { render } from "./FirmwarePage.vue?vue&type=template&id=a224bd70"
import script from "./FirmwarePage.vue?vue&type=script&lang=js"
export * from "./FirmwarePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductManage/ConfigManagement/components/Motor/FirmwarePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a224bd70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a224bd70', __exports__)) {
    api.reload('a224bd70', __exports__)
  }
  
  module.hot.accept("./FirmwarePage.vue?vue&type=template&id=a224bd70", () => {
    api.rerender('a224bd70', render)
  })

}


export default __exports__